export enum AssetsView {
  LIST = 'list',
  CARD = 'card',
}

export enum AssetsGrouping {
  NONE = 'none',
  TAGS = 'tags',
}
